import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { firestore } from '../../../../firebase';
import AddPlayer from '../EditHostcup/AddPlayer';
import AddRound from '../EditHostcup/AddRound';
import AllRoundsHostcup from './AllRoundsHostcup';

function SingleHostcupAdminFirebase() {

    const {id} = useParams();

    function useQuery() {
        return new URLSearchParams(useLocation().runde);
    }
    let query = useQuery();

    console.log(query, "QUERY")

    const [activeItem, setActiveItem] = useState("1");
    const [hostcup, setHostcup] = useState();

    useEffect(() => {

        try {
            const singleHostcupRef = firestore.collection("hostcup").doc(id);
            singleHostcupRef.onSnapshot(doc => {
                const hostcup = {id: doc.id, ...doc.data()}
                setHostcup(hostcup)
            })
        } catch (error) {
            
        }

    }, [id])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    return (
        <div className="container my-3">

            <div className="row my-4">
                <div className="col-6">
                    <button  onClick={() => toggle("1")} className={`btn btn-primary btn-sm btn-block ${activeItem === "1" && "active"}`}>Rediger</button>
                </div>
                <div className="col-6">
                    <button onClick={() => toggle("2")} className={`btn btn-primary btn-sm btn-block ${activeItem === "2" && "active"}`}>Runder</button>
                </div>
            </div>

            <h2>{hostcup?.title}</h2>

            {activeItem === "1" && (
                <React.Fragment>
                    <h4>Legg til spiller i turnering</h4>
                    <AddPlayer id={id} />
                    <h4>Legg til runde</h4>
                    <AddRound id={hostcup?.id} />
                </React.Fragment>
            )}
            {activeItem === "2" && (
                <AllRoundsHostcup id={hostcup?.id} />
            )}
            
        </div>
    )

}
export default SingleHostcupAdminFirebase